import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Save, Building2 } from "lucide-react";

const FIELDS = [
  { key: "company_name", label: "Business / Company Name", ph: "ST FRANCIS XAVIER ICE PLANT", toggle: null },
  { key: "gstin", label: "GSTIN", ph: "e.g. 29ABCDE1234F1Z5", toggle: "show_gstin" },
  { key: "mobile", label: "Mobile Number", ph: "e.g. +91 98765 43210", toggle: "show_mobile" },
  { key: "address", label: "Address", ph: "Full business address", toggle: "show_address" },
  { key: "email", label: "Email", ph: "e.g. billing@business.com", toggle: "show_email" },
];

export default function BusinessSettings() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/settings").then((r) => setS(r.data)); }, []);

  const set = (k, v) => setS((prev) => ({ ...prev, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings", s);
      toast.success("Business details saved");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  if (!s) return <p className="text-slate-400">Loading…</p>;

  return (
    <div data-testid="business-settings-page" className="max-w-2xl">
      <h1 className="font-chivo font-black text-3xl text-slate-900 flex items-center gap-2"><Building2 className="h-7 w-7 text-sky-600" /> Print Settings</h1>
      <p className="text-slate-500 mt-1 mb-6">These details appear on the printed bill header. Use the toggle to choose which lines are shown.</p>

      <div className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm space-y-5">
        {FIELDS.map((f) => (
          <div key={f.key} className="grid gap-1.5">
            <div className="flex items-center justify-between">
              <Label>{f.label}</Label>
              {f.toggle && (
                <div className="flex items-center gap-2 text-xs text-slate-500">
                  <span>Show on bill</span>
                  <Switch checked={!!s[f.toggle]} onCheckedChange={(v) => set(f.toggle, v)} data-testid={`toggle-${f.toggle}`} />
                </div>
              )}
            </div>
            <Input data-testid={`settings-${f.key}`} value={s[f.key] || ""} placeholder={f.ph} onChange={(e) => set(f.key, e.target.value)} />
          </div>
        ))}
        <div className="pt-2 border-t border-slate-100">
          <Button data-testid="save-settings-button" className="bg-sky-600 hover:bg-sky-700" onClick={save} disabled={saving}>
            <Save className="h-4 w-4 mr-1.5" /> {saving ? "Saving…" : "Save Business Details"}
          </Button>
        </div>
      </div>
    </div>
  );
}
